import type { SxProps } from '@mui/material';
import { Box, Popover } from '@mui/material';
import { useState } from 'react';
import { Button } from '@/shared/ui';
import { ColorPlate } from '../ColorPlate/ColorPlate';
import { PRESET_COLORS } from './presetColors';

interface Props {
  sx?: SxProps;
  value: string;
  onChange: (v: string) => void;
}

export function ColorPicker({ value, onChange, sx }: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (color: string) => () => {
    onChange(color);
  };

  return (
    <div>
      <Button
        sx={sx}
        color="secondary"
        variant="outlined"
        onClick={handleClick}
      >
        <ColorPlate color={value} />
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box
          sx={{
            p: 2,
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 2,
          }}
        >
          {PRESET_COLORS.map((color) => {
            return (
              <Button
                key={color}
                sx={{ p: 0, minWidth: 0 }}
                onClick={handleChange(color)}
              >
                <ColorPlate color={color} />
              </Button>
            );
          })}
        </Box>
      </Popover>
    </div>
  );
}
